export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
          <div className="flex-shrink-0 w-40 h-40 md:w-48 md:h-48 rounded-2xl bg-background-950 flex items-center justify-center">
            <div className="text-center">
              <i className="ri-smartphone-line text-4xl md:text-5xl text-background-50"></i>
              <p className="mt-2 text-xs text-background-300 font-medium">扫码下载</p>
            </div>
          </div>
          <div className="flex-1 text-center lg:text-left">
            <h3 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
              随时随地，追剧不停
            </h3>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl">
              快看影视适配手机、平板、电脑全终端，无需下载即可流畅观看高清电视剧。
              收藏本站或添加至桌面，随时随地秒开好剧，通勤路上、午休间隙都能轻松追剧。
            </p>
            <div className="mt-4 flex flex-wrap items-center gap-3 justify-center lg:justify-start">
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-200 text-xs text-foreground-600">
                <i className="ri-android-line"></i> Android
              </span>
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-200 text-xs text-foreground-600">
                <i className="ri-apple-line"></i> iOS
              </span>
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-200 text-xs text-foreground-600">
                <i className="ri-computer-line"></i> 网页版
              </span>
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-200 text-xs text-foreground-600">
                <i className="ri-tablet-line"></i> 平板
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}